// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__UbHdU","itemTitle":"ClientEmergencyInfo_itemTitle__aolB6","itemText":"ClientEmergencyInfo_itemText__20drx"};